import React, {useState} from "react";
import {Link} from "react-router-dom";
import {ChartBarIcon, ChartLineIcon, RocketLaunchIcon, ChatsIcon, HandWavingIcon} from "@phosphor-icons/react";
import {useAuth} from "context/auth.context";
import {useProfile} from "context/profile.context";
import SideDrawer from "components/drawers/side.drawer";
import SettingsPanel from "components/panels/settings/settings.panel";
import FeedbackPanel from "components/panels/feedback/feedback.panel";
import logo from "../../assets/pocketwatch-logo-01.svg";
import icon from "../../assets/pocketwatch-icon-01@2x.png";

const Navigation = () => {
  const {user} = useAuth();
  const {displayName, profilePicSignedUrl} = useProfile();
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  const toggleMenu = () => { setIsMenuActive(!isMenuActive); };
  const openSettings = () => { setIsMenuActive(false); setIsSettingsOpen(true); };
  const openFeedback = () => { setIsMenuActive(false); setIsFeedbackOpen(true); };
  const handleNavigation = () => { setIsMenuActive(false); window.scrollTo(0, 0); };

 



  return (
    <>
      <div className={"Navigation" + (isMenuActive ? " active" : "")}>
        {/* MENU BUTTON  */}
        <div className="MenuButton" onClick={toggleMenu}>
          <img className="Logo" src={icon} alt="Pocketwatch Logo" />
          <div className="Typeform" style={{maskImage: `url(${logo})`, WebkitMaskImage: `url(${logo})`}} />
        </div>

        {/* USER BUTTON  */}
        <div className="UserButtons ">
          <div className="link pointer" onClick={openFeedback}>
            <div className="icon large">
              <ChatsIcon />
            </div>
            <p className="large">Feedback</p>
          </div>
          <div className="link"  onClick={openSettings}>
            <div className="icon large">
            <div className="ProfilePic">
              {profilePicSignedUrl ? 
              <img src={profilePicSignedUrl} alt="profile pic" /> :
              <p className="large">{(displayName || user?.email || "?")[0].toUpperCase()}</p>}
            </div>
            </div>
  
            <p className="large">{displayName}</p>
          </div>
        </div>

        {/* MENU PANEL  */}
        <div className={"MenuPanel" }>
          <Link to="/networth" className="link" onClick={handleNavigation}>
            <div className="icon large">
              <ChartBarIcon />
            </div>

            <p className="large">Net Worth</p>
          </Link>
          <Link to="/futureworth" className="link" onClick={handleNavigation}>
            <div className="icon large">
              <RocketLaunchIcon />
            </div>

            <p className="large">Futureworth</p>
          </Link>
          <Link to="/timeline" className="link" onClick={handleNavigation}>
            <div className="icon large">
              <ChartLineIcon />
            </div>
            <p className="large">Timeline</p>
          </Link>
          <Link to="/onboarding" className="link" onClick={handleNavigation}>
            <div className="icon large">
              <HandWavingIcon />
            </div>
            <p className="large">Onboarding</p>
          </Link>
        </div>
      </div>

      {isSettingsOpen && (
        <SideDrawer onCancel={() => setIsSettingsOpen(false)}>
          <SettingsPanel onClose={() => setIsSettingsOpen(false)} />
        </SideDrawer>
      )}

      {isFeedbackOpen && (
        <SideDrawer onCancel={() => setIsFeedbackOpen(false)}>
          <FeedbackPanel onClose={() => setIsFeedbackOpen(false)} />
        </SideDrawer>
      )}
    </>
  );
};

export default Navigation;
